export const genericVariables = {
    borderRadiusPill: '1000px',
    borderRadiusXs: '8px',
    borderRadiusS: '16px',
    borderRadiusM: '32px',
    borderRadiusL: '64px',
    dropShadowM: 'drop-shadow(0 2px 4px color-mix(in hsl, #D7DDE6 5%, transparent)) drop-shadow(0 2px 4px color-mix(in hsl, #D7DDE6 5%, transparent))',
    dropShadowL: 'drop-shadow(0 6px 1px color-mix(in hsl, #D7DDE6 10%, transparent)) drop-shadow(0 24px 32px color-mix(in hsl, #8190A8 5%, transparent))'
};

const colorPalette = {
    light: '#FAFAFA',
    dark: '#0A0A0A',
    green: '#00D400',
    red: '#f44336',
    yellow: '#FFCC00',
    reddish: '#B35D40',
    primary50: '#E6EBF2',
    primary100: '#D7DDE6',
    primary200: '#A4AFC1',
    primary300: '#8190A8',
    primary400: '#5F728F',
    primary500: '#3D5376',
    primary600: '#31425E',
    primary700: '#253247',
    primary800: '#18212F',
    primary900: '#0C1118',
    neutral50: '#E9F2FC',
    neutral100: '#CEDFEB',
    neutral200: '#B4C8D8',
    neutral300: '#98B2C5'
};

export const colorLightVariables = {
    textMain: colorPalette.primary700,
    textMainAlt: colorPalette.light,
    textMainAltHover: '#F0F0F0',
    textPrimary: colorPalette.primary800,
    textSecondary: colorPalette.primary400,
    textTertiary: colorPalette.primary300,
    textAccent: colorPalette.primary500,
    textError: colorPalette.reddish,
    textBodySecondary: colorPalette.primary600,
    backgroundPage: colorPalette.light,
    backgroundPageHover: '#F0F0F0',
    backgroundSectionLight: '#F0F3F7',
    backgroundSectionDark: colorPalette.primary50,
    backgroundPrimary: colorPalette.primary500,
    backgroundPrimaryDisabled: colorPalette.primary300,
    backgroundPrimaryHover: colorPalette.primary600,
    backgroundSurfaceAccent: colorPalette.primary50,
    backgroundSurfaceAccentHover: colorPalette.primary100,
    backgroundTableHead: '#f0f2f5',
    strokePrimary: colorPalette.primary300,
    strokeSecondary: colorPalette.primary200,
    strokeTertiary: colorPalette.light,
    strokeTertiaryHover: '#F0F0F0',
    strokeError: colorPalette.reddish,
    strokeSuccess: `rgba(0, 216, 26, 0.2)`,
    iconMain: colorPalette.primary500,
    iconLight: colorPalette.primary300,
    iconError: colorPalette.reddish,
    iconErrorBright: colorPalette.red,
    iconWarning: colorPalette.yellow,
    iconSuccess: colorPalette.green
};

export const colorDarkVariables: Record<keyof typeof colorLightVariables, string> = {
    textMain: colorPalette.primary700,
    textMainAlt: colorPalette.light,
    textMainAltHover: '#F0F0F0',
    textPrimary: colorPalette.primary800,
    textSecondary: colorPalette.primary400,
    textTertiary: colorPalette.primary300,
    textAccent: colorPalette.primary500,
    textError: colorPalette.reddish,
    textBodySecondary: colorPalette.primary600,
    backgroundPage: colorPalette.light,
    backgroundPageHover: '#F0F0F0',
    backgroundSectionLight: '#F0F3F7',
    backgroundSectionDark: colorPalette.primary50,
    backgroundPrimary: colorPalette.primary500,
    backgroundPrimaryDisabled: colorPalette.primary300,
    backgroundPrimaryHover: colorPalette.primary600,
    backgroundSurfaceAccent: colorPalette.primary50,
    backgroundSurfaceAccentHover: colorPalette.primary100,
    backgroundTableHead: '#f0f2f5',
    strokePrimary: colorPalette.primary300,
    strokeSecondary: colorPalette.primary200,
    strokeTertiary: colorPalette.light,
    strokeTertiaryHover: '#F0F0F0',
    strokeError: colorPalette.reddish,
    strokeSuccess: `rgba(0, 216, 26, 0.2)`,
    iconMain: colorPalette.primary500,
    iconLight: colorPalette.primary300,
    iconError: colorPalette.reddish,
    iconErrorBright: colorPalette.red,
    iconWarning: colorPalette.yellow,
    iconSuccess: colorPalette.green
};

export const themeVariables = {
    light: colorLightVariables,
    dark: colorDarkVariables
} as const;

export type Theme = 'light' | 'dark';
export type ColorToken = keyof typeof colorLightVariables;
export type ThemeToken = ColorToken | keyof typeof genericVariables;
